import { render, staticRenderFns } from "./goods_list.vue?vue&type=template&id=62099276&scoped=true&"
import script from "./goods_list.vue?vue&type=script&lang=ts&"
export * from "./goods_list.vue?vue&type=script&lang=ts&"
import style0 from "./goods_list.vue?vue&type=style&index=0&id=62099276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62099276",
  null
  
)

export default component.exports